import React from 'react';
import * as S from './styles';

function TextThrough({children}) {
  return <S.Textthrough>
    {children}
  </S.Textthrough>;
}

export default TextThrough;